import { render, staticRenderFns } from "./signData.vue?vue&type=template&id=21e12ee7&scoped=true&"
import script from "./signData.vue?vue&type=script&lang=js&"
export * from "./signData.vue?vue&type=script&lang=js&"
import style0 from "./signData.vue?vue&type=style&index=0&id=21e12ee7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e12ee7",
  null
  
)

export default component.exports